import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'People',
  icon: 'mdi-account-multiple-outline',
  path: '/reports/people',
  menuFilters: {
    $and: [
      { countryCode: { $in: ['us', 'ca'] } },
      { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
    ],
  },
  children: [
    {
      path: '/reports/people/employeeRoster',
      name: 'Employee Roster',
      meta: { id: 'mc-employeeRoster', permission: 'mtPeople' },
      component: () => import('./EmployeeRoster.vue'),
      ...addPermissionsToRoute(['mtPeople']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
    },
    {
      path: '/reports/people/birthdaysAnniversaries',
      name: 'Birthdays & Anniversaries',
      meta: {
        id: 'mc-birthdaysAnniversaries',
        permission: 'mtPeople',
      },
      component: () =>
        import('./birthdayAnniversary/BirthdaysAnniversaries.vue'),
      ...addPermissionsToRoute(['mtPeople']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
    },
    {
      path: '/reports/people/overTimeAudit',
      name: 'Overtime Audit',
      meta: { id: 'reports-overtimeAudit', permission: 'mtPeople' },
      component: () => import('./OvertimeAudit.vue'),
      ...addPermissionsToRoute(['mtPeople']),
    },
    {
      path: '/reports/people/employeeLookBack',
      name: 'Emp Hours Look Back',
      meta: { id: 'reports-empHoursLookBack', permission: 'mtPeople' },
      component: () => import('./EmployeeHoursLookBack.vue'),
      ...addPermissionsToRoute(['mtPeople']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
    },
    {
      path: '/reports/people/employeePunches',
      name: 'Employee Punches',
      meta: { id: 'reports-employeePunches', permission: 'mtPeople' },
      component: () => import('./EmployeePunches.vue'),
      ...addPermissionsToRoute(['mtPeople']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
    },
    {
      path: '/reports/people/timeAttendance',
      name: 'Time and Attendance',
      meta: { id: 'reports-timeAndAttendance', permission: 'mtPeople' },
      component: () => import('./TimeAndAttendance.vue'),
      ...addPermissionsToRoute(['mtPeople']),
    },
    {
      path: '/reports/people/payrollLedger',
      name: 'Payroll Ledger',
      meta: { id: 'reports-payrollLedger', permission: 'mtPeople' },
      component: () => import('./PayrollLedger.vue'),
      ...addPermissionsToRoute(['mtPeople']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
    },
  ],
};

export default routes;
